import { PriceListListResponseType } from "@sellar-io/api-v2/types";

const filterDiscountsWithContainerType = ({
  priceListDiscountList,
  containerType,
}: {
  priceListDiscountList: PriceListListResponseType[number]["PriceListDiscounts"];
  containerType: "bottle" | "can";
}) => {
  return priceListDiscountList.filter(
    (priceListDiscount) =>
      containerType === priceListDiscount.itemType ||
      priceListDiscount.itemType === null, // 'any' container type
  );
};

export const getPriceListsWithDiscountContainerType = ({
  priceListList,
  containerType,
}: {
  priceListList: PriceListListResponseType;
  containerType: "bottle" | "can";
}) => {
  return priceListList
    .filter((priceList) => {
      return !!filterDiscountsWithContainerType({
        priceListDiscountList: priceList.PriceListDiscounts,
        containerType,
      }).length;
    })
    .map((priceList) => {
      const priceListDiscounts = filterDiscountsWithContainerType({
        priceListDiscountList: priceList.PriceListDiscounts,
        containerType,
      });

      return {
        ...priceList,
        PriceListDiscounts: priceListDiscounts,
      };
    });
};
